package com.parmartechnologies.commerce.feature.inventory.viewModel.uom

import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.core.feature.inventory.uom.model.UOM
import com.parmartechnologies.core.feature.inventory.uom.network.CreateUOMRequest
import com.parmartechnologies.core.feature.inventory.uom.network.RetrieveUOMRequest
import com.parmartechnologies.core.feature.inventory.uom.network.UpdateUOMRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.handler.UOMHandler
import com.parmartechnologies.commerce.feature.inventory.network.uom.UOMNetwork
import com.parmartechnologies.commerce.feature.inventory.repository.UOMRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.table.inventory.uom.UOMDatabaseTable
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class UOMViewModel(val business: Business, val repository: UOMRepository = UOMHandler.shared().repository) :
    AppViewModel() {

    val allUOM: StateFlow<List<UOM>>
        get() = repository.uomLiveData

    val selectedUOM: StateFlow<UOM?>
        get() = repository.selectedUOM

    fun fetchAllUOM() {
        loadFromStorage()
        if(allUOM.value.isEmpty()) {
            val request =
                RetrieveUOMRequest(business._id)
            // startLoading()
            CoroutineScope(Job() + Dispatchers.Default).launch {
                UOMNetwork().retrieve(request) {
                    UOMDatabaseTable().insert(it?.payload) {}
                    stopLoading()
                    loadFromStorage()
                }
            }
        }
    }

    fun loadAllUOM() {
        fetchAllUOM()
    }

    private fun loadFromStorage() {
        UOMDatabaseTable().retrieve(business._id) { data ->
            scope.launch {
                repository.uomLiveData.emit(data)
            }
        }
    }

    fun getUOMById(id: String?, callback: (UOM?) -> Unit) {
        UOMDatabaseTable().find(id ?: "") { data ->
            scope.launch {
                callback(data)
            }
        }
    }

    fun createNewUOM(name: String, description: String, completion: () -> Unit) {
        val request = CreateUOMRequest(
            name,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            UOMNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allUOM: MutableList<UOM> =
                            repository.allUOM.value.toMutableList()
                        allUOM.add(it.payload!!)
                        repository.uomLiveData.emit(allUOM)
                        UOMDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }

    fun updateUOM(name: String, id: String, description: String, completion: () -> Unit) {
        val request = UpdateUOMRequest(
            name,
            id,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            UOMNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allUOM: MutableList<UOM> =
                            repository.allUOM.value.toMutableList()
                        allUOM.add(it.payload!!)
                        repository.uomLiveData.emit(allUOM)
                        UOMDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }
}